/*
  Turns Horizon's infinite scroll into a "Load more" button.
  Horizon loads the next page when a sentinel span scrolls into view.
  This keeps the sentinel hidden so nothing loads on its own, then reveals
  it briefly when the button is pressed. Horizon does the fetching, and the
  button survives filter changes because the list is re-checked on every
  DOM change.
*/
(function () {
  var LABEL = 'Load more';
  var LOADING = 'Loading';

  function ensure(list) {
    var sentinel = list.querySelector('[ref="viewMoreNext"]');
    var grid = list.querySelector('[ref="grid"]');
    if (!sentinel || !grid) return;

    if (!list.canwellLoading) sentinel.style.display = 'none';

    var wrapper = list.querySelector('.canwell-load-more');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'canwell-load-more';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'button-secondary canwell-load-more__button';
      button.textContent = LABEL;
      button.addEventListener('click', function () {
        list.canwellLoading = true;
        button.disabled = true;
        button.textContent = LOADING;
        sentinel = list.querySelector('[ref="viewMoreNext"]') || sentinel;
        sentinel.style.display = 'block';
        sentinel.style.height = '1px';
        window.setTimeout(function () {
          list.canwellLoading = false;
          ensure(list);
        }, 1500);
      });
      wrapper.appendChild(button);
    }
    if (wrapper.parentElement !== sentinel.parentElement || wrapper.previousElementSibling !== sentinel) {
      sentinel.insertAdjacentElement('afterend', wrapper);
    }

    var lastPage = Number(grid.dataset.lastPage || 1);
    var lastItem = grid.lastElementChild;
    var currentPage = lastItem && lastItem.dataset.page ? Number(lastItem.dataset.page) : 1;
    var btn = wrapper.querySelector('button');
    if (currentPage >= lastPage) {
      wrapper.hidden = true;
    } else {
      wrapper.hidden = false;
      if (!list.canwellLoading) {
        btn.disabled = false;
        btn.textContent = LABEL;
      }
    }
  }

  function setup(list) {
    if (list.canwellLoadMore) return;
    list.canwellLoadMore = true;
    list.canwellLoading = false;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        ensure(list);
      });
    }).observe(list, { childList: true, subtree: true });
    ensure(list);
  }

  function scan() {
    document.querySelectorAll('results-list[infinite-scroll="true"]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
